<template>  
  <v-container fluid grid-list-lg class="ma-0 pa-0">
    <v-card flat>
      <v-card-text>
        <v-layout row>
          <v-flex xs6 md3 lg2 v-if="!disabled.addr_idkab">
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idpro"
              label="Provinsi"
              :items="provinsi"
              item-text="name"
              item-value="id"
              :loading="provinsiLoading"
              :disabled="disabled.addr_idpro"
              clearable
              autocomplete="off"
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkab"
              label="Kabupaten/Kota"
              :items="kabupaten"
              item-text="name"
              item-value="id"
              :loading="kabupatenLoading"
              :disabled="disabled.addr_idkab"
              clearable autocomplete="off"
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkec"
              label="Kecamatan"
              :items="kecamatan"
              item-text="name"
              item-value="id"
              :loading="kecamatanLoading"
              :disabled="disabled.addr_idkec"
              clearable autocomplete="off"
            />
          </v-flex>
          <v-flex xs6 md3 lg2>  
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.addr_idkel"
              label="Kelurahan"
              :items="kelurahan"
              item-text="name"
              item-value="id"
              :loading="kelurahanLoading"
              :disabled="disabled.addr_idkel"
              clearable autocomplete="off"
            />
          </v-flex>  
          <!--
          <v-flex xs6 md3 lg2>                   
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.tps_id"
              label="TPS"
              :items="tps"
              item-text="name"
              item-value="id"
              :loading="tpsLoading"
              clearable autocomplete="off"
            />
          </v-flex>-->          
        </v-layout>        
      </v-card-text>
      <v-divider />
      <v-card-text>
        <v-layout row>
          <v-flex xs12 md6>
            <template v-if="loading">
              <v-card>
                <v-skeleton-loader                
                  style="width:100%"
                  type="article, date-picker"
                ></v-skeleton-loader>
              </v-card>
            </template>
            <template v-else>
              <v-btn color="success" dark @click="export2excel('dpt')" large>
                <v-icon left>select_all</v-icon>.xls
              </v-btn>
              <v-layout row v-if="fm.addr_idkec">              
                <v-flex xs12>
                  <v-card :set="area = kecamatan.find(x=>x.id==fm.addr_idkec)">
                    <v-card-text v-if="area">      
                      <v-layout row>              
                        <v-progress-circular
                          :rotate="360"
                          :size="150"
                          :width="20"
                          :value="parseInt(parseInt(area.lembarDone)/parseInt(area.lembar)*100)"
                          :color="color"
                          class="mr-4"
                        >
                          <span class="title">{{ area.lembarDone }}/{{area.lembar}}</span>
                        </v-progress-circular>
                        <v-flex>
                          <h3>{{ area.name }}</h3>
                          <h5>{{ area.parent_name }}</h5>
                          <h1 class="mt-3">{{ parseFloat(parseInt(area.lembarDone)/parseInt(area.lembar)*100).toFixed(1) }}%</h1>
                        </v-flex>
                      </v-layout>  
                    </v-card-text>                  
                  </v-card>
                </v-flex>
                <v-flex md2 xs4 v-for="(item, i) in kelurahan" :key="i">
                  <v-card>
                    <v-card-text class="pa-0 pt-2 text-center">                    
                      <v-progress-circular
                        :rotate="360"
                        :size="80"
                        :width="10"
                        :value="parseInt(parseInt(item.lembarDone)/parseInt(item.lembar)*100)"
                        :color="color"
                      >
                        {{ item.lembarDone }}/{{item.lembar}}
                      </v-progress-circular>
                      <p class="mb-0 caption">{{item.name}}</p>
                    </v-card-text>                  
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout row v-else-if="fm.addr_idkab">
                <v-flex xs12>
                  <v-card :set="area = kabupaten.find(x=>x.id==fm.addr_idkab)">
                    <v-card-text  v-if="area">      
                      <v-layout row>              
                        <v-progress-circular
                          :rotate="360"
                          :size="150"
                          :width="20"
                          :value="parseInt(parseInt(area.lembarDone)/parseInt(area.lembar)*100)"
                          :color="color"
                          class="mr-4"
                        >
                          <span class="title">{{ area.lembarDone }}/{{area.lembar}}</span>
                        </v-progress-circular>
                        <v-flex>
                          <h3>{{ area.name }}</h3>
                          <h5>{{ area.parent_name }}</h5>
                          <h1 class="mt-3">{{ parseFloat(parseInt(area.lembarDone)/parseInt(area.lembar)*100).toFixed(1) }}%</h1>
                        </v-flex>
                      </v-layout>  
                    </v-card-text>                  
                  </v-card>
                </v-flex>
                <v-flex md2 xs4 v-for="(item, i) in kecamatan" :key="i">
                  <v-card>
                    <v-card-text class="pa-0 pt-2 text-center">                    
                      <v-progress-circular
                        :rotate="360"
                        :size="80"
                        :width="10"
                        :value="parseInt(parseInt(item.lembarDone)/parseInt(item.lembar)*100)"
                        :color="color"
                      >
                        {{ item.lembarDone }}/{{item.lembar}}
                      </v-progress-circular>
                      <p class="mb-0 caption">{{item.name}}</p>                      
                    </v-card-text>                  
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout row v-else-if="fm.addr_idpro">
                <v-flex xs12>
                  <v-card :set="area = provinsi.find(x=>x.id==fm.addr_idpro)">
                    <v-card-text  v-if="area">      
                      <v-layout row>              
                        <v-progress-circular
                          :rotate="360"
                          :size="150"
                          :width="20"
                          :value="parseInt(parseInt(area.lembarDone)/parseInt(area.lembar)*100)"
                          :color="color"
                          class="mr-4"
                        >
                          <span class="title">{{ area.lembarDone }}/{{area.lembar}}</span>
                        </v-progress-circular>
                        <v-flex>
                          <h3>{{ area.name }}</h3>
                          <h5>{{ area.parent_name }}</h5>
                          <h1 class="mt-3">{{ parseFloat(parseInt(area.lembarDone)/parseInt(area.lembar)*100).toFixed(1) }}%</h1>
                        </v-flex>
                      </v-layout>  
                    </v-card-text>                  
                  </v-card>
                </v-flex>              
                <v-flex md2 xs4 v-for="(item, i) in kabupaten" :key="i">
                  <v-card>
                    <v-card-text class="pa-0 pt-2 text-center">                    
                      <v-progress-circular
                        :rotate="360"
                        :size="80"
                        :width="10"
                        :value="parseInt(parseInt(item.lembarDone)/parseInt(item.lembar)*100)"
                        :color="color"
                      >
                        {{ item.lembarDone }}/{{item.lembar}}
                      </v-progress-circular>
                      <p class="mb-0 caption">{{item.name}}</p>
                    </v-card-text>                  
                  </v-card>
                </v-flex>
              </v-layout>
            </template>
          </v-flex>   
          <v-flex xs12 md6>
            <v-card>              
              <echart v-if="!loading" :option="option1" :height="height1+'px'" />
              <template v-else>
                <v-skeleton-loader                
                  style="width:100%"
                  type="card, article"
                ></v-skeleton-loader>
              </template>
            </v-card>               
          </v-flex>   
          <v-flex xs12 md12>
            <v-card>
              <v-card-text class="pa-0" id="exportdpt" style="position:relative; overflow:auto">
                <v-btn color="success" dark @click="export2excel('dpt')" small style="position:absolute; left:2px; top:2px">
                    <v-icon left>select_all</v-icon>.xls
                  </v-btn>
                  <table class="tb-normal" style="width:100%">
                    <thead class="white--text blue">
                      <tr>
                        <th>No.</th>
                        <template>
                          <th v-if="fm.addr_idkel">TPS</th>
                          <th v-else-if="fm.addr_idkec">Kelurahan</th>
                          <th v-else-if="fm.addr_idkab">Kecamatan</th>
                          <th v-else-if="fm.addr_idpro">Kebupaten/Kota</th>                                                
                        </template>                      
                        <th class="text-right">Jumlah TPS</th>
                        <th class="text-right">Jumlah DPT</th>
                        <th class="text-right">Sample</th>
                        <th class="text-right">Sebaran</th>
                      </tr>                      
                    </thead>
                    <template v-if="fm.addr_idkel">
                      <tbody>
                        <tr v-for="(item, i) in tps" :key="'kec'+i">
                          <td valign="top">{{i+1}}</td>
                          <td valign="top">{{item.name}}</td>
                          <td v-if="i==0" class="text-right" valign="top" :rowspan="tps.length">{{tps.length}}</td>
                          <td valign="top" class="text-right">{{item.dpt}}</td>
                          <td v-if="i==0" class="text-right" valign="top" :rowspan="tps.length">{{kelurahan.find(x=>x.id==fm.addr_idkel).lembar}}</td>
                          <td valign="top" class="text-right">{{item.lembarDone}}</td>
                        </tr>
                      </tbody>
                      <tfoot v-if="tps.length == 0">
                        <tr><th colspan="6">No Data Result</th></tr>                      
                      </tfoot>
                      <tfoot v-else>
                        <tr>
                          <th colspan="2" class="text-left">Total</th>
                          <td class="text-right"><strong>{{tps.length}}</strong></td>  
                          <td class="text-right"><strong>{{totalDpt(tps).dpt}}</strong></td>                                                                                                    
                          <td class="text-right"><strong>{{kelurahan.find(x=>x.id==fm.addr_idkel).lembar}}</strong></td>                                                                                                    
                          <td class="text-right"><strong>{{totalDpt(tps).lembarDone}}</strong></td>                                                                                                    
                        </tr>  
                      </tfoot>
                    </template> 
                    <template v-else>
                      <tbody>
                        <tr v-for="(item, i) in getNodesActive()" :key="'kec'+i">
                          <td valign="top">{{i+1}}</td>
                          <td valign="top">{{item.name}}</td>
                          <td valign="top" class="text-right">{{item.jumlahTps}}</td>
                          <td valign="top" class="text-right">{{item.dpt}}</td>
                          <td valign="top" class="text-right">{{item.lembar}}</td>
                          <td valign="top" class="text-right">{{item.lembarDone}}</td>
                        </tr>
                      </tbody>
                      <tfoot v-if="getNodesActive().length == 0">
                        <tr><th colspan="5">No Data Result</th></tr>                      
                      </tfoot>
                      <tfoot v-else>
                        <tr>
                          <th colspan="2" class="text-left">Total</th>
                          <td class="text-right"><strong>{{totalDpt(getNodesActive()).jumlahTps}}</strong></td>
                          <td class="text-right"><strong>{{totalDpt(getNodesActive()).dpt}}</strong></td>
                          <td class="text-right"><strong>{{totalDpt(getNodesActive()).lembar}}</strong></td>
                          <td class="text-right"><strong>{{totalDpt(getNodesActive()).lembarDone}}</strong></td>
                        </tr>  
                      </tfoot>
                    </template>                                                                                                    
                  </table>
              </v-card-text>
            </v-card>
          </v-flex>                        
        </v-layout>
      </v-card-text>      
    </v-card>
  </v-container>
</template>

<script>
import Table2Excel  from 'table2excel.js';  
import Echart from '@/app/components/other/echart';
import { debounce } from 'lodash'
import Model from '@/app/models/Report'
const  model = new Model()

export default {
  components:{Echart},
  props:{
    jilid : {type:Object}
  },
  data () {
    return {
      area:{},
      fm:{ tps_id:null, addr_idpro:null, addr_idkab: null, addr_idkec:null, addr_idkel:null},    
      disabled : {addr_idpro : false, addr_idkab: false, addr_idkec: false, addr_idkel:false},
      provinsi  : [], kabupaten : [], kecamatan : [], kelurahan : [], tps:[],
      provinsiLoading  : false, kabupatenLoading : false, kecamatanLoading : false, kelurahanLoading : false, tpsLoading:false,
      loading : false, firstime:true,
      height1 : 390, height2 : 390, color:null,
      option1 :  {
        title: {
            text: 'Sebaran (%)',
            subtext: 'Responden'
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: "{b} : {c}%"    
        },
        legend: {
            data: ['responden']
        },
        toolbox: {
            show : true,
            x: 'right',
            feature : {
                mark : {show: true},
                //dataView : {show: true, readOnly: false},
                //restore : {show: true},
                saveAsImage : {show: true, title:'Pict'}
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
        },
        yAxis: {
            type: 'category',
            data: ['巴西','印尼','美国','印度','中国','世界人口(万)']
        },
        series: [
            {
                name: 'responden',
                type: 'bar',
                label: {
                  normal: {
                    show: true,
                    position: 'right',
                    formatter: "{c}%"    
                  },                  
                },
                data: [18203, 23489, 29034, 104970, 131744, 630230]
            },           
        ]
      },
    } 
  },
  computed:{
        
  },
  watch:{
    'fm.addr_idpro'(newId){if(newId){      
      model.node({id:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(res=>{this.provinsi.push(res)});
      this.kabupatenLoading = true; //this.fm.addr_idkab = null;
      model.kabupaten({parent:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(data=>{
        this.kabupaten=data; this.kabupatenLoading = false;  
        this.fm.addr_idkab = this.fm.addr_idkab && data.find(x=>x.id === this.fm.addr_idkab) ? this.fm.addr_idkab : null;         
      })
    }},
    'fm.addr_idkab'(newId){
      if(newId){      
        this.kecamatanLoading = true;
        model.kecamatan({parent:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(data=>{
          this.kecamatan=data; this.kecamatanLoading = false;
          this.fm.addr_idkec = this.fm.addr_idkec && data.find(x=>x.id===this.fm.addr_idkec) ? this.fm.addr_idkec:null;
          if(this.kecamatan.find(x=>x.id===this.fm.addr_idkec)){
            this.fm.addr_postcode = this.fm.addr_postcode ? this.fm.addr_postcode:this.kecamatan.find(x=>x.id===this.fm.addr_idkec).kodepos;
          }  
        })
        model.node({id:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(data=>{this.fm.addr_idpro = data.parent_id;})
      } else {
        this.fm.addr_idkec = null; this.kecamatan = []; 
      }
    },
    'fm.addr_idkec'(newId){
      if(newId){      
        this.kelurahanLoading = true; 
        model.kelurahan({parent:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(data=>{
          this.kelurahan=data; this.kelurahanLoading = false;
          this.fm.addr_idkel = this.fm.addr_idkel && data.find(x=>x.id===this.fm.addr_idkel) ? this.fm.addr_idkel : null;           
        })      
        if(this.kecamatan.find(x=>x.id===newId)){
          let kodepos = this.kecamatan.find(x=>x.id===newId).kodepos;
          this.fm.addr_postcode = this.fm.addr_postcode ? this.fm.addr_postcode : kodepos; 
        }  
      } else {
        this.fm.addr_idkel = null; this.kelurahan = [];
      }
    },   
    'fm.addr_idkel'(newId, oldId){if(oldId===null && newId !== null){
      this.tpsLoading = true;
      model.node({id:newId,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(data=>{
        this.kelurahan.push(data); 
        model.tps({idkel:data.id,jilid_id:this.jilid.id}).then(res=>{
          this.tps = res.data;
          this.tpsLoading = false;
        })
      })  
    } else if(this.kelurahan.find(x=>x.id===newId)){
      this.tpsLoading = true;
      model.tps({idkel:newId,jilid_id:this.jilid.id}).then(res=>{
        this.tps = res.data;
        this.tpsLoading = false;
      })
    }},
    'fm': {
      handler : debounce(function () {      
        this.readItems()
      }, 400), 
      deep:true,
    },       
  },  
  mounted() {
    this.loading = true;
    this.init();
  },
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    init(){
      if(this.jilid.node_id){
        model.node({id:this.jilid.node_id,jilid_id:this.jilid.id,expand:'lembar,lembarDone,jumlahTps'}).then(res=>{
          if(res.level){
            this.disabled.addr_idpro = false;
            this.disabled.addr_idkab = false;
            this.disabled.addr_idkec = false;
            this.disabled.addr_idkel = false;
            this.fm.addr_idpro = null;
            this.fm.addr_idkab = null;
            this.fm.addr_idkec = null;
            this.fm.addr_idkel = null;
            switch(parseInt(res.level)){
              case 1: this.fm.addr_idpro = res.id; 
                this.disabled.addr_idpro = true;
                break;
              case 2: this.fm.addr_idkab = res.id; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                break;
              case 3: this.fm.addr_idkec = res.id; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                this.disabled.addr_idkec = true;
                break;
              case 4: this.fm.addr_idkel = res.id; 
                this.disabled.addr_idpro = true;
                this.disabled.addr_idkab = true;
                this.disabled.addr_idkec = true;
                this.disabled.addr_idkel = true;
                break;
            }
          }            
        })
      }
      /*if(Array.isArray(this.jilid.quetionnaires)){
        let no = 0;
        this.jilid.quetionnaires.forEach(q=>{
          this.pertanyaans.push({id:q.no, name:q.question, loading:true,option:{}});
          if( no < 2){
            this.fm2.nomors.push(q.no);
            no++;
          }                              
        })
      }*/
    },

    readItems () {
      this.loading = true
      
      const params = {        
        jilid_id: this.jilid.id,
        idpro:this.fm.addr_idpro,
        idkab:this.fm.addr_idkab,
        idkec:this.fm.addr_idkec,
        idkel:this.fm.addr_idkel,
        expand:'quetionnaires'
      }      

      model.sebaran(params).then(data => {
        if(Array.isArray(data)){
          this.height1 = data.length*40 > 417 ? data.length*40 : 417;
          this.option1.yAxis.data = [];
          this.option1.series[0].data = [];
          this.color = this.$color();
          this.option1.series[0].itemStyle = {color:this.color};
          let total = 0;
          data.forEach(item=>{
            this.option1.yAxis.data.push(item.area_name+"\n["+item.people+"]");
            total += parseInt(item.people);
          });
          data.forEach(item=>{
            this.option1.series[0].data.push(parseFloat(parseInt(item.people)/total*100).toFixed(2));            
          });
        }
        this.loading = false;              
      })
    },  
        
    export2excel(i){
      var filename = 'Report.'+i+'.';
      filename    += this.$moment().format('DDMMYY.HHmm');
      new Table2Excel('#export'+i+' table',{
        plugins: [{
          workcellCreated ({ workbook, tables, worksheet, table, workcell, cell, cellStyle, rowRange, colRange }) {
            workcell.style = {
              ...workcell.style,
              font: {},
              color: '#000'
            }
          }
        }]
      }).export(filename);
    },

    getNodesActive(){
      if(this.fm.addr_idkel){
        return this.tps;
      } else if(this.fm.addr_idkec){
        return this.kelurahan;
      } else if(this.fm.addr_idkab){
        return this.kecamatan;
      } else if(this.fm.addr_idpro){
        return this.kabupaten;
      } else {
        return [];
      }
    },

    totalDpt(items){
      let dpt = 0, lembar = 0, lembarDone = 0, jumlahTps =0;
      items.forEach(item=>{
        dpt += parseInt(item.dpt)
        lembar += parseInt(item.lembar)
        lembarDone += parseInt(item.lembarDone)
        jumlahTps += parseInt(item.jumlahTps)
      })
      return {dpt:dpt, lembar:lembar, lembarDone: lembarDone, jumlahTps:jumlahTps};
    },
  },  
}
</script>
<style>
.tb-normal{    
  border-collapse: collapse;
}
.tb-normal td, .tb-normal th {
  border: 1px solid #ddd;
  padding: 4px 6px;
}
</style>